import { useState, useEffect } from "react";
import { toast } from "sonner";
import { deleteQuestion, getQuiz } from "../services/quizService";
import { useAuth } from "../contexts/authContext";

const useQuizQuestions = (quizId) => {
  let {user} = useAuth()
  const [quiz, setQuiz] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuizDetails = async () => {
      try {
        const data = await getQuiz(quizId);
        if (!user.is_admin && data?.is_admin_owner){
          setError('You don\'t have permission to edit this quiz')
        }     
        setQuiz(data);
      } catch (error) {
        console.error("Error fetching quiz details:", error);
        if(error.status === 404){
          setError('Quiz not found')
          toast.error("Quiz not found")
        } else {
          setError('Something went wrong. Failed to load quiz data...')
          toast.error("Failed to load quiz details")
        }
      } finally {
        setLoading(false);
      }
    };

    if (quizId) {
      fetchQuizDetails();
    }
  }, [quizId]);

  return {
    quiz,
    error,
    setQuiz,
    loading,
    setLoading,
  };
};

export default useQuizQuestions;
